import React, { useState } from 'react';
import { Check, Star, XIcon } from 'lucide-react';
import { WebinarMCStickyBar } from '../components/WebinarMCStickyBar';
export function WebinarMCPage() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  return <div className="min-h-screen bg-white font-sans text-gray-800" data-id="element-4798">
      {/* Registration Popup */}
      {isPopupOpen && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4" onClick={() => setIsPopupOpen(false)} data-id="element-4799">
          <div className="bg-white rounded-2xl p-6 w-full max-w-sm relative" onClick={e => e.stopPropagation()} data-id="element-4800">
            <button onClick={() => setIsPopupOpen(false)} className="absolute top-3 right-3 text-gray-400 hover:text-gray-600" data-id="element-4801">
              <XIcon className="w-6 h-6" data-id="element-4802" />
            </button>
            <div className="flex justify-center items-center w-full pt-4" data-id="element-4803">
              <iframe src="https://app.webinargeek.com/embed/7dfdb212-bc5c-456b-9231-b35ea1f59a5c?cst=src-meta_cmp-mcc_pt-optin" height="500" width="330" title="Webinar Communiceren Met Je Hond Stressless Dogs" style={{
            border: 'none',
            borderRadius: '15px',
            backgroundColor: 'white',
            maxWidth: '100%'
          }} data-id="element-4804"></iframe>
            </div>
            <p className="text-xs text-gray-500 text-center mt-3" data-id="element-4805">
              We HATEN spam. Je e-mailadres is 100% veilig
            </p>
            <div className="flex items-center gap-3 mt-3 px-2" data-id="element-4806">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kJ5b6tBbH8hDNt52JG84mT/Scherm%C2%ADafbeelding_2025-08-15_om_15.44.02.png" alt="Amee Buijs" className="w-9 h-9 rounded-full object-cover flex-shrink-0" data-id="element-4807" />
              <p className="text-xs text-gray-600 leading-snug" data-id="element-4808">
                Dit webinar wordt gegeven door Amee Buijs, honden
                gedragsdeskundige met 10 jaar ervaring.
              </p>
            </div>
          </div>
        </div>}

      {/* Navigation */}
      <nav className="w-full border-b border-gray-200 py-4 px-6 bg-white" data-id="element-4809">
        <div className="flex justify-center md:justify-between items-center" data-id="element-4810">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6YKzftRpGkz4jKTtn8FQxB/Logo_Stressless_Dogs_%288%29_%284%29.png" alt="Stressless Dogs" className="h-10 object-contain" data-id="element-4811" />
          <div className="hidden md:block" data-id="element-4812">
            <div className="trustpilot-widget" data-locale="nl-NL" data-template-id="5419b6ffb0d04a076446a9af" data-businessunit-id="65017f0060003ffc450ac45e" data-style-height="20px" data-style-width="500px" data-theme="light" data-id="element-4813">
              <a href="https://nl.trustpilot.com/review/stresslessdogs.nl" target="_blank" rel="noopener noreferrer" data-id="element-4814">
                Trustpilot
              </a>
            </div>
          </div>
        </div>
        <div className="md:hidden flex justify-center mt-3 w-full" data-id="element-4815">
          <div className="trustpilot-widget" data-locale="nl-NL" data-template-id="5419b6ffb0d04a076446a9af" data-businessunit-id="65017f0060003ffc450ac45e" data-style-height="20px" data-style-width="100%" data-token="d24193a8-3943-4d9c-bcbd-f0b97f9d6fb9" data-id="element-4816">
            <a href="https://nl.trustpilot.com/review/stresslessdogs.nl" target="_blank" rel="noopener" data-id="element-4817">
              Trustpilot
            </a>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="max-w-6xl mx-auto px-4 py-12 md:py-20 grid md:grid-cols-12 gap-12 items-center" data-id="element-4818">
        <div className="md:col-span-7" data-id="element-4819">
          <p className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-4 text-center md:text-left" data-id="element-4820">
            Gratis Online Webinar: Communiceren met je Hond
          </p>
          <h1 className="text-3xl md:text-5xl font-extrabold text-[#1a2b4a] mb-6 leading-tight text-center md:text-left" data-id="element-4821">
            Leer Je Hond Écht Begrijpen - Zodat Je Weet Wat Hij Denkt, Voelt en
            Wilt
          </h1>
          <div className="md:hidden mb-6" data-id="element-4822">
            <img src="https://cdn.magicpatterns.com/uploads/qnzT9c8MEjsZMbSpGR8q95/MCC_webinar_preview.png" alt="Webinar preview: Communiceren met je Hond" className="w-full rounded-2xl shadow-lg" data-id="element-4823" />
          </div>
          <button onClick={() => setIsPopupOpen(true)} className="md:hidden mx-auto block bg-[#f27a6b] hover:bg-[#e0695a] text-white font-bold py-4 px-10 rounded-full text-lg transition-colors shadow-md mb-4" data-id="element-4824">
            Ja, ik wil mijn hond begrijpen →
          </button>
          <div className="md:hidden flex items-center justify-center gap-4 mb-8" data-id="element-4825">
            <div className="flex -space-x-3" data-id="element-4826">
              <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&h=100&fit=crop&crop=faces" className="w-10 h-10 rounded-full border-2 border-white" alt="User" data-id="element-4827" />
              <img src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=100&h=100&fit=crop&crop=faces" className="w-10 h-10 rounded-full border-2 border-white" alt="User" data-id="element-4828" />
              <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=faces" className="w-10 h-10 rounded-full border-2 border-white" alt="User" data-id="element-4829" />
            </div>
            <div data-id="element-4830">
              <p className="font-bold text-lg text-[#1a2b4a]" data-id="element-4831">97.283+</p>
              <p className="text-xs text-gray-600" data-id="element-4832">
                Baasjes volgden al dit webinar
              </p>
            </div>
          </div>
          <p className="text-lg text-gray-700 mb-8 leading-relaxed" data-id="element-4833">
            Ontdek in dit gratis 90-minuten webinar hoe je de hondentaal leert
            lezen - zodat je je hond beter begrijpt en weet hoe je moet reageren
          </p>

          <ul className="space-y-4 mb-8" data-id="element-4834">
            {['Hoe je je hond beter leert begrijpen - ook als je al jaren honden hebt', 'De hondentaal leren lezen - zodat je ziet wat hij denkt, voelt en wilt', 'Hoe je angst, stress en onzekerheid herkent - voordat het escaleert', 'Waarom je hond soms niet luistert - en wat hij je eigenlijk probeert te vertellen', 'De 3 kernbehoeften van elke hond - en hoe deze alles verklaren', 'Hoe je de signalen herkent die je nu mist - zodat je weet hoe je moet reageren'].map((item, i) => <li key={i} className="flex items-start" data-id="element-4835">
                <Check className="w-6 h-6 text-blue-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-4836" />
                <span className="text-gray-700 font-medium" data-id="element-4837">{item}</span>
              </li>)}
          </ul>

          <div className="hidden md:flex items-center gap-4" data-id="element-4838">
            <div className="flex -space-x-3" data-id="element-4839">
              <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&h=100&fit=crop&crop=faces" className="w-12 h-12 rounded-full border-2 border-white" alt="User" data-id="element-4840" />
              <img src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=100&h=100&fit=crop&crop=faces" className="w-12 h-12 rounded-full border-2 border-white" alt="User" data-id="element-4841" />
              <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=faces" className="w-12 h-12 rounded-full border-2 border-white" alt="User" data-id="element-4842" />
            </div>
            <div data-id="element-4843">
              <p className="font-bold text-xl text-[#1a2b4a]" data-id="element-4844">97.283+</p>
              <p className="text-sm text-gray-600" data-id="element-4845">
                Baasjes volgden al dit webinar
              </p>
            </div>
          </div>
        </div>

        <div className="md:col-span-5 flex justify-center" data-id="element-4846">
          <div className="p-6 rounded-3xl w-full max-w-sm mx-auto" data-id="element-4847">
            <div className="flex justify-center items-center w-full" data-id="element-4848">
              <iframe src="https://app.webinargeek.com/embed/7dfdb212-bc5c-456b-9231-b35ea1f59a5c?cst=src-meta_cmp-mcc_pt-optin" height="550" width="330" title="Webinar Communiceren Met Je Hond Stressless Dogs" style={{
              border: 'none',
              borderRadius: '25px',
              backgroundColor: 'white',
              maxWidth: '100%'
            }} data-id="element-4849"></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* 3 Steps Section */}
      <section className="bg-gray-50 py-20" data-id="element-4850">
        <div className="max-w-6xl mx-auto px-4 text-center" data-id="element-4851">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a2b4a] mb-16" data-id="element-4852">
            Leer de hondentaal in drie stappen
          </h2>

          <div className="grid md:grid-cols-3 gap-12 mb-12" data-id="element-4853">
            <div className="flex flex-col items-center" data-id="element-4854">
              <img src="https://cdn.magicpatterns.com/uploads/7G3FddFkmDX1PP48Js3VUV/agenda_icon_(1).png" alt="Agenda icoon" className="w-32 h-32 object-contain mb-6" data-id="element-4855" />
              <h3 className="text-xl font-bold text-[#1a2b4a] mb-3" data-id="element-4856">Stap 1.</h3>
              <p className="text-gray-600" data-id="element-4857">
                Vul het formulier in en reserveer jouw plekje
              </p>
            </div>
            <div className="flex flex-col items-center" data-id="element-4858">
              <img src="https://cdn.magicpatterns.com/uploads/oxDbACMiW4Zh5cMbL7Ry7C/cursor_webinar_v3_(1).png" alt="Webinar knop icoon" className="w-32 h-32 object-contain mb-6" data-id="element-4859" />
              <h3 className="text-xl font-bold text-[#1a2b4a] mb-3" data-id="element-4860">Stap 2.</h3>
              <p className="text-gray-600" data-id="element-4861">
                Klik tegen die tijd op de link in je e-mail om direct deel te
                nemen
              </p>
            </div>
            <div className="flex flex-col items-center" data-id="element-4862">
              <img src="https://cdn.magicpatterns.com/uploads/swcfYXFhsSevmDxKpdEyU7/vrouw_hond_knuffel_(1).png" alt="Vrouw knuffelt hond" className="w-32 h-32 object-contain mb-6" data-id="element-4863" />
              <h3 className="text-xl font-bold text-[#1a2b4a] mb-3" data-id="element-4864">Stap 3.</h3>
              <p className="text-gray-600" data-id="element-4865">
                Leer in 90 minuten de hondentaal begrijpen
              </p>
            </div>
          </div>

          <button onClick={() => setIsPopupOpen(true)} className="bg-[#f27a6b] hover:bg-[#e0695a] text-white font-bold py-4 px-10 rounded-full text-lg transition-colors shadow-md" data-id="element-4866">
            Inschrijven webinar
          </button>
        </div>
      </section>

      {/* Social Proof / Testimonials */}
      <section className="py-20 bg-[#fbfaf8]" data-id="element-4867">
        <div className="max-w-6xl mx-auto px-4 text-center" data-id="element-4868">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a2b4a] mb-16 max-w-3xl mx-auto leading-tight" data-id="element-4869">
            Duizenden baasjes gingen je voor - en zeggen allemaal hetzelfde:{' '}
            <br data-id="element-4870" />
            <span className="italic" data-id="element-4871">"Ik begrijp mijn hond nu pas echt."</span>
          </h2>

          {/* Videos */}
          <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-4872">
            <div className="rounded-xl overflow-hidden shadow-lg bg-black" data-id="element-4873">
              <div style={{
              padding: '177.78% 0 0 0',
              position: 'relative'
            }} data-id="element-4874">
                <iframe src="https://player.vimeo.com/video/1086787571?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="MCC testimonial 2" data-id="element-4875"></iframe>
              </div>
            </div>
            <div className="rounded-xl overflow-hidden shadow-lg bg-black" data-id="element-4876">
              <div style={{
              padding: '177.78% 0 0 0',
              position: 'relative'
            }} data-id="element-4877">
                <iframe src="https://player.vimeo.com/video/1086787549?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="MCC testimonial 3" data-id="element-4878"></iframe>
              </div>
            </div>
            <div className="rounded-xl overflow-hidden shadow-lg bg-black" data-id="element-4879">
              <div style={{
              padding: '177.78% 0 0 0',
              position: 'relative'
            }} data-id="element-4880">
                <iframe src="https://player.vimeo.com/video/1086787601?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="MCC testimonial 1" data-id="element-4881"></iframe>
              </div>
            </div>
          </div>

          {/* Review Grid */}
          <div className="grid md:grid-cols-2 gap-6 mb-16 text-left" data-id="element-4882">
            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-4883">
              <div className="flex items-center mb-4" data-id="element-4884">
                <div className="flex text-green-500 mr-2" data-id="element-4885">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-4886" />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-4887">8 jul 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-4888">
                Hele fijne cursus. Aanrader zelfs voor de ervaren honden
                liefhebber.
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-4889">
                Mijn hele leven heb ik al honden maar altijd heb ik het gevoel
                gehad dat ik ze niet helemaal begreep. In korte tijd zoveel
                geleerd. Wat mij het meeste aanspreekt is dat het zonder
                commando's gaat maar via communiceren.
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-4890">
                - Nicolette
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-4891">
              <div className="flex items-center mb-4" data-id="element-4892">
                <div className="flex text-green-500 mr-2" data-id="element-4893">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-4894" />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-4895">3 sep 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-4896">
                Niet goed maar uitstekend!
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-4897">
                Je leert in een hele fijne manier je hond begrijpen en anders
                naar je hond kijken. Amée is een zeer lieve vrouw met een hart
                voor honden en dat merk je zeer goed.
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-4898">
                - Tine Oetzmann
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-4899">
              <div className="flex items-center mb-4" data-id="element-4900">
                <div className="flex text-green-500 mr-2" data-id="element-4901">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-4902" />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-4903">20 apr 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-4904">
                Dit was de eerste keer dat ik een online hondencursus volgde...
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-4905">
                Ik heb er veel van opgestoken over de communicatie. Het valt
                echt op dat omdat ik zelf anders ben gaan opstellen, mijn honden
                nu veel rustiger communiceren met andere honden.
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-4906">
                - Margreet
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-4907">
              <div className="flex items-center mb-4" data-id="element-4908">
                <div className="flex text-green-500 mr-2" data-id="element-4909">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-4910" />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-4911">13 aug 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-4912">
                Ik vond het prettig mijn ervaring op te halen...
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-4913">
                Voorbereid zijn op de puppy die ik krijg. Goed gewerkt!
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-4914">
                - Henne Buskermolen
              </p>
            </div>
          </div>

          <button onClick={() => setIsPopupOpen(true)} className="bg-[#f27a6b] hover:bg-[#e0695a] text-white font-bold py-4 px-10 rounded-full text-lg transition-colors shadow-md" data-id="element-4915">
            Inschrijven webinar
          </button>
        </div>
      </section>

      {/* About Amee */}
      <section className="py-20 bg-white" data-id="element-4916">
        <div className="max-w-5xl mx-auto px-4 grid md:grid-cols-2 gap-12 items-center" data-id="element-4917">
          <div data-id="element-4918">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1a2b4a] mb-6 leading-tight" data-id="element-4919">
              Hoi, ik ben Amee en ik geef dit webinar.
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-4920">
              <p data-id="element-4921">
                Ik ben Amee de Bruijn, hondengedragsdeskundige en oprichter van
                StresslessDogs.nl. Maar veel belangrijker: ik ben iemand die
                precies begrijpt wat je voelt als je hond gedrag vertoont dat je
                niet snapt.
              </p>
              <p data-id="element-4922">
                In de afgelopen jaren heb ik meer dan 15.000 hondenbaasjes mogen
                helpen hun hond beter te begrijpen. En wat ik keer op keer zie:
                de meeste frustratie komt niet door een 'slechte' hond. Het komt
                doordat baasjes en honden letterlijk twee verschillende talen
                spreken.
              </p>
              <p data-id="element-4923">
                Zodra je de hondentaal leert begrijpen, verdwijnt de frustratie.
                Je ziet wat je hond denkt, voelt en wilt. De strijd maakt plaats
                voor samenwerking. En de band wordt onverwoestbaar.
              </p>
              <p data-id="element-4924">
                Daarom werk ik uitsluitend met methodes gebaseerd op vertrouwen,
                veiligheid en echte communicatie. Geen dwang, geen straf. Alleen
                liefde en begrip.
              </p>
              <p data-id="element-4925">
                Dit webinar is mijn manier om de hondentaal met zoveel mogelijk
                baasjes te delen. Omdat ik geloof dat elke hond en elk baasje de
                kans verdient om elkaar écht te begrijpen.
              </p>
            </div>
          </div>
          <div className="rounded-2xl overflow-hidden shadow-xl" data-id="element-4926">
            <img src="https://cdn.magicpatterns.com/uploads/vXmyJc5cCVvbLnBaXGCixn/682f298cbb713_AmeemetSophietje1.png" alt="Amee met Sophietje" className="w-full h-auto object-cover" data-id="element-4927" />
          </div>
        </div>
      </section>

      {/* Bottom Registration */}
      <section className="py-20 bg-gray-50" data-id="element-4928">
        <div className="max-w-md mx-auto px-4" data-id="element-4929">
          <div className="p-6 rounded-3xl w-full" data-id="element-4930">
            <div className="flex justify-center items-center" data-id="element-4931">
              <iframe src="https://app.webinargeek.com/embed/7dfdb212-bc5c-456b-9231-b35ea1f59a5c?cst=src-meta_cmp-mcc_pt-optin" height="550" width="330" title="Webinar Communiceren Met Je Hond Stressless Dogs" style={{
              border: 'none',
              borderRadius: '25px',
              backgroundColor: 'white'
            }} data-id="element-4932"></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-white border-t border-gray-200 py-12" data-id="element-4933">
        <div className="max-w-6xl mx-auto px-4 flex flex-col items-center text-center" data-id="element-4934">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6YKzftRpGkz4jKTtn8FQxB/Logo_Stressless_Dogs_%288%29_%284%29.png" alt="Stressless Dogs" className="h-12 object-contain mb-6" data-id="element-4935" />
          <p className="font-semibold text-[#1a2b4a] mb-2" data-id="element-4936">
            Voor liefdevolle hondenbaasjes
          </p>
          <a href="mailto:amee@stresslessdogs.nl" className="text-blue-600 hover:underline mb-8" data-id="element-4937">
            amee@stresslessdogs.nl
          </a>

          <div className="text-xs text-gray-500 max-w-3xl leading-relaxed" data-id="element-4938">
            <p className="mb-2" data-id="element-4939">
              © 2025 Stressless Dogs. Alle rechten voorbehouden.
            </p>
            <p data-id="element-4940">
              Deze website maakt gebruik van cookies en vergelijkbare
              technologieën voor analytische en advertentiedoeleinden. Deze
              pagina is een advertorial voor Stressless Dogs. Stressless Dogs is
              een onafhankelijk bedrijf en is op geen enkele wijze verbonden aan
              of onderdeel van Meta (voorheen Facebook). Deze advertentie wordt
              getoond via het Meta advertentieplatform, maar Meta is niet
              verantwoordelijk voor de inhoud of diensten aangeboden door
              Stressless Dogs.
            </p>
          </div>
        </div>
      </footer>
      <WebinarMCStickyBar onClickCTA={() => setIsPopupOpen(true)} data-id="element-4941" />
    </div>;
}